const passwordLength = 8;

// Returns null if password is valid
export function VerifyPassword(
    password: string,
): string | null {
    // Check passwords long enough
    if (password.length < passwordLength) {
        return `Password must be ${passwordLength} characters in length`;
    }
    if (/ /.test(password)) {
        return "Password cannot contain spaces";
    }
    if (/[a-z]/.test(password)  === false) {
        return "Password must contain at least one lowercase letter";
    }
    if (/[A-Z]/.test(password)  === false) {
        return "Password must contain at least one uppercase letter";
    }
    if (/[0-9]/.test(password)  === false) {
        return "Password must contain at least one number";
    }
    if (/^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/.test(password)  === false) {
        return "Password must contain at least one symbol";
    }
    if (/(?=\P{L})(?=\P{N})/.test(password)) {
        return "Password contains in-valid characters";
    }
    return null;
}

// Code from: https://stackoverflow.com/a/46181
export function validateEmail(email: string) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}


